import { render } from "./choosearea.vue?vue&type=template&id=5a8b8516"
import script from "./choosearea.vue?vue&type=script&lang=js"
export * from "./choosearea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__